import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/mandate.css";
import { store } from "./store";
import { Provider } from "react-redux";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CURRENTENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

if (CURRENTENVIRONMENT === "PROD") {
  (function () {
    const screenWidth = window.innerWidth;

    const currentPath = window.location.pathname + window.location.search + window.location.hash;
    const protocol = window.location.protocol;
    const currentHost = window.location.host;

    const desktopHost = "web.paymeindia.in";
    const mobileHost = "m-web.paymeindia.in";

    const isDesktop = screenWidth > 991;

    const isTargetHost =
      (isDesktop && currentHost === desktopHost) ||
      (!isDesktop && currentHost === mobileHost);

    if (!isTargetHost) {
      const targetHost = isDesktop ? desktopHost : mobileHost;
      window.location.replace(`${protocol}//${targetHost}${currentPath}`);
    }
  })();
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js')
      .then(function () {})
      .catch(function () {});
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <main id="main-content" role="main">
        <ScrollToTop>
          <App />
        </ScrollToTop>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={1}
        />
      </main>
    </BrowserRouter>
  </Provider>
);
